import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import Dashboard from "../../../components/commonComponents/Embeddable/Dashboard";
import { defineDashboardVariables } from "../../../api_calls/ReportSettings";

const ReportView = ({ configFilterArr, configTabName, configTabType, configEmbeddableId, viewMode }) => {
    const currentStateData = useSelector((state) => state.userSelections);

    let dashboardVariables = defineDashboardVariables(configTabType, configTabName, configFilterArr, viewMode);

    return typeof configEmbeddableId !== "undefined" && configEmbeddableId !== "" ?
        <Dashboard
            embedDashboardId={configEmbeddableId}
            variables={dashboardVariables}
            filterConfig={{
                "number_root": currentStateData.campaign_detail.root_company_id.toString(),
            }}
        />
        :
        <Box>No dashboard available</Box>;
};

export default ReportView;
